import { cx } from '../cx';
import { Modal, type ModalProps } from './Modal';

// temp_WideModal — 임시 공통 컴포넌트(UI파트 검수 후 승격 대상). 처음 쓴 곳: 인디플래너 자재파트너배정 팝업.
// 표·목록과 작성 패널을 한 화면에 나란히 두는 업무 팝업용 넓은 Modal — 글자가 줄바꿈되지 않게 xl(880)보다 넓힌다.
// 기존 표준으로 안 되는 이유: Modal 크기는 sm·md·lg·xl·full 뿐이라 xl(880)과 full(풀스크린) 사이가 없다.
// 동작(포커스 트랩·Esc·바깥 클릭 닫기·머리·버튼 영역)은 Modal 그대로 — 최대 폭만 1120 으로 바꾼다.
// 승격 시 Modal size 에 'xxl'(가칭) 로 넣는 것을 제안한다. (인디플래너 시공파트너배정 팝업은 자체 창으로 1200 을 쓴다)
export type TempWideModalProps = Omit<ModalProps, 'size'>;

export function Temp_WideModal({ className, ...props }: TempWideModalProps) {
  return <Modal {...props} size="xl" className={cx('max-w-[1120px]', className)} />; // dq-ignore: 모달 폭 토큰 없음(xl 880 다음 단계 임시값, 승격 때 표준 크기로)
}
